import { useCheckoutContext, useCreatePaymentLink, useCreatePartialPaymentLink } from '@ztechapps/order.webui'

export const useTemplateCreatePaymentLink = () => {
  const { createPaymentLink: createFullPaymentLink } = useCreatePaymentLink()
  const { createPaymentLink: createPartialPaymentLink } = useCreatePartialPaymentLink()

  const checkoutContext = useCheckoutContext()
  const orderDocument = checkoutContext.orderDocumentResult

  const hasPartialPayments = checkoutContext.hasPartialPayments

  const createPaymentLink = hasPartialPayments ? createPartialPaymentLink : createFullPaymentLink

  const payWithCard = async () => {
    if (orderDocument?.document?.paymentBalance?.balance <= 0) throw new Error('No balance to pay')
    return await createPaymentLink()
  }

  return { payWithCard }
}
